import React, { useState, useEffect } from "react";
import { useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Benefit from './benefit'
import { formatWithCommas } from "../../helpers/common";


const Benefits = ({getBenefitsDetails}) => {
    const navigate = useNavigate();
    const params = useParams();
    const contract_id = params.contract_id;
    const [benefits, setBenefits] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [selectedBenefits, setSelectedBenefits] = useState([]);
 
    


    useEffect(() => {

        getBenefits();
       
       

    }, []);

    
    const getBenefits = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-benefits-by-id/"+contract_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                setBenefits(response?.data?.benefits);
            })
            .catch(function (error) {
                if(error.status==403)  navigate("/login")
else
                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });
    }
    
  

    const handleCheckboxChange = (id) => {
       
        // console.log(e.target.checked);
         if (selectedBenefits.indexOf(id) === -1) {
              setSelectedBenefits([...selectedBenefits,id]);
         } else {
           setSelectedBenefits(selectedBenefits.filter((s) => s != id));
         }
       };
 
 
     const removeBenefits = async (selected=0) => {
 
         let params = {contract_id:contract_id};
         if(selected == 1){
             params["benefit_ids"] = selectedBenefits;
             
         }
         axios.post(process.env.REACT_APP_API_URL + "/remove-benefits-by-id", params ,{
             headers: {
                 'Content-Type': 'application/json'
             },
             withCredentials: true
         })
             .then(function (response) {
                 
                 if (response?.data?.status) {
                     
                     setEditMode(false);
                     getBenefits();
                     setSelectedBenefits([]);
 
                 }
 
 
 
             })
             .catch(function (error) {
                 if (error.status == 403) navigate("/login")
                 else
                     Swal.fire({ icon: "error", title: "Error", text: error.message });
 
             });
     }

   
    return (


        <div className="card" >

        <div className="card-title" >

            <div className="box-title color-white fs-18 fs-helvetica" >Benefits</div>
            {benefits && benefits.length > 0  &&
                <>
                {editMode ?
                    <button className="btn btn-link fs-12" onClick={() => { setEditMode(false); setSelectedBenefits([]); }}  >Cancel</button>
                    :
                    <button className="btn btn-link fs-12" onClick={() => setEditMode(true)}  >Edit</button>
                }
                </>
                }

        </div>

        <div className="card-content" >

        {benefits && benefits.map((s, index) => {
                        return (
            <div  className={"list-layout "+ ((selectedBenefits.indexOf(s.benefit_id) !== -1) && "selected")}
            onClick = {() => editMode && handleCheckboxChange(s.benefit_id)}
            >
                {editMode &&
                    <input name="benefits[]" type="checkbox" className="chk chk-primary" 
                    value={s.benefit_id}
                    checked={(selectedBenefits.indexOf(s.benefit_id) !== -1)}
                   
                     />
                }
                <label className="color-light fs-12  list-text">${formatWithCommas(s.benefit_amount)}</label>
                <button className="btn btn-sm btn-secondary list-button ">{s.tag_title}</button>
            </div>
                        )}
                    )}

            <div className={"list-layout "+ (selectedBenefits?.length > 0 ? "justify-content-space-between":"justify-content-end" )  }  >
               <Benefit benefits={benefits} getBenefitsDetails={getBenefitsDetails} updateBenefitList={getBenefits}  selectedBenefits={selectedBenefits} editMode={editMode} removeBenefits={removeBenefits}  />  
            </div>



        </div>

    </div>






    );
};

export default Benefits;